export const ResultNoticeType = {
    OJS: "OJS",
    ATTACHMENT: "ATTACHMENT"
}
export default ResultNoticeType;